export { AccountOpeningV2BeneficiaryIntroStep } from './AccountOpeningV2BeneficiaryIntroStep';
